import { Form, Grid, Select, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { FC } from 'react';

import { messages } from './TaxSection.messages';
import type { TaxSectionProps } from './TaxSection.types';

export const TaxSection: FC<TaxSectionProps> = (props) => {
    const { qa, taxCodes } = props;

    return (
        <Form.Part>
            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                <TextField
                    name='taxNumber'
                    qa={domHelpers.generateDataQa(qa, 'tax-id')}
                    label={messages.taxIdNumberLabel}
                    placeholder={messages.taxIdNumberPlaceholder}
                    maxLength={constants.xeroConstants.TAX_NUMBER_MAX_LENGTH}
                />

                <TextField
                    name='companyNumber'
                    qa={domHelpers.generateDataQa(qa, 'company-reg-number')}
                    label={messages.companyNumberLabel}
                    placeholder={messages.companyNumberPlaceholder}
                    maxLength={constants.xeroConstants.COMPANY_NUMBER_MAX_LENGTH}
                />

                <Select
                    name='salesTax'
                    itemNameKey='text'
                    qa={domHelpers.generateDataQa(qa, 'sales-tax')}
                    label={messages.salesTaxLabel}
                    placeholder={messages.selectPlaceholder}
                    items={taxCodes}
                    autocomplete
                />

                <Select
                    name='purchaseTax'
                    itemNameKey='text'
                    qa={domHelpers.generateDataQa(qa, 'purchase-tax')}
                    label={messages.purchaseTaxLabel}
                    placeholder={messages.selectPlaceholder}
                    items={taxCodes}
                    autocomplete
                />
            </Grid>
        </Form.Part>
    );
};

TaxSection.displayName = 'TaxSection';
